import homeVideoSearchItem from "fragments/homeVideos/homeVideoSearchItem"
import gql from "graphql-tag"

const SEARCH_HOME_VIDEOS = gql`
  ${homeVideoSearchItem}

  query searchHomeVideos($searchHomeVideosInput: SearchHomeVideosInput!) {
    searchHomeVideos(searchHomeVideosInput: $searchHomeVideosInput) {
      ...HomeVideoSearchItem
    }
  }
`

export default SEARCH_HOME_VIDEOS
